<template>
	<div class="order_list_page">
		<div class="filter_box">
			<div class="flex flex_wrap">
				<a-range-picker v-model="filterData.timeDate" class="mr12 mb10" @change="onChangeDate" />
				<a-input v-model="filterData.orderNo" style="width: 300px" class="mr12 mb10"
					placeholder="请输入订单编号"></a-input>

				<a-select v-model="filterData.orderStatus" style="width: 150px" class="mr12 mb10" allowClear
					placeholder="订单状态" @change="getData(1)" show-search option-filter-prop="label" :filter-option="filterOption">
					<a-select-option v-for="(item, index) of $enums.orderStatusEnum" :key="index" :value="item.value">
						{{ item.label }}
					</a-select-option>
				</a-select>
				<a-input v-model="filterData.email" style="width: 300px" class="mr12 mb10"
					placeholder="email"></a-input>
				<a-input v-model="filterData.whatsApp" style="width: 300px" class="mr12 mb10"
					placeholder="WhatsApp"></a-input>
				<a-input v-model="filterData.inviteUserEmail" style="width: 300px" class="mr12 mb10"
					placeholder="推荐人"></a-input>
				<a-select v-model="filterData.complaintStatus" style="width: 150px" class="mr12 mb10" allowClear
					placeholder="申诉状态" @change="getData(1)"  show-search option-filter-prop="label" :filter-option="filterOption">
					<a-select-option v-for="(item, index) of $enums.verifyStatusEnum" :key="index" :value="item.value">
						{{ item.label }}
					</a-select-option>
				</a-select>
				<a-select v-model="filterData.simulateStatus" style="width: 150px" class="mr12 mb10" allowClear
					placeholder="模拟用户" @change="getData(1)"  show-search option-filter-prop="label" :filter-option="filterOption">
					<a-select-option v-for="(item, index) of $enums.simulateStatusEnum" :key="index"
						:value="item.value">
						{{ item.label }}
					</a-select-option>
				</a-select>
				<a-input v-model="filterData.managerName" style="width: 300px" class="mr12 mb10"
					placeholder="操作人"></a-input>
				<!-- <a-select v-model="filterData.orderByTitle" style="width: 150px" class="mr12 mb10" allowClear
					placeholder="排序使用" @change="getData(1)">
					<a-select-option v-for="(item, index) of orderByTitleList" :key="index" :value="item.value">
						{{ item.label }}
					</a-select-option>
				</a-select> -->
				<!-- <a-input v-model="filterData.giftCardId" style="width: 300px" class="mr12 mb10"
					placeholder="卡片名称ID"></a-input> -->
				<a-select v-model="filterData.giftCardId" style="width: 150px" class="mr12 mb10" placeholder="卡片名称" @change="getCountData" show-search option-filter-prop="name" :filter-option="filterOption">
					<a-select-option v-for="(item, index) of tableCardData" :key="index"
						:value="item.giftCardId">
						{{ item.name }}
					</a-select-option>
				</a-select>


				<!-- <a-input v-model="filterData.countryId" style="width: 300px" class="mr12 mb10"
					placeholder="国家ID"></a-input> -->
				<a-select v-model="filterData.countryId" style="width: 150px" class="mr12 mb10" placeholder="卡片国家" @change="getData(1)" show-search option-filter-prop="name" :filter-option="filterOption">
						<a-select-option v-for="(item, index) of filterData.giftCardId?tableCountryData:[]" :key="index" :value="item.countryId">
							{{ item.name }}
						</a-select-option>
					</a-select>



				<a-input v-model="filterData.commodityName" style="width: 300px" class="mr12 mb10"
					placeholder="分类价格"></a-input>
				<a-input v-model="filterData.nickname" style="width: 300px" class="mr12 mb10"
					placeholder="会员昵称"></a-input>
				<a-button class="mr12 mb10" type="primary" @click="toSearch(true)">搜索</a-button>
				<a-button class="mr12 mb10" @click="toSearch(false)">清空</a-button>
				<a-upload  v-if="hasPermission('PER_ORDERIMPORT')" class="mr12 mb10" name="file" :show-upload-list="false" :before-upload="beforeUpload"
					:customRequest="customRequest" accept=".xlsx,.xls">
					<a-button type="primary" :loading="uploadingLoading">
						导入
					</a-button>
				</a-upload>

			</div>

		</div>
		<a-table  :columns="columns"  :data-source="tableData" :sorter="false" :pagination="pageInfo" @change="changePage"
			:loading="loading" :scroll="{ x: true }" :rowKey="record => record.orderId">
			<template slot="nickname" slot-scope="text, record">
				<div>
					<span style="padding-right: 5px;cursor: pointer;" v-if="record.nickname">{{record.nickname}}</span>
					<span style="padding:1px 5px;background-color: rgb(235,96,97);color: #fff;border-radius: 3px;user-select: none;" v-if="record.vipName">{{record.vipName}}</span>
				</div>
			</template>
			<template slot="email" slot-scope="text, record">
				<div @click="toEmail(record.email)">
					<span style="cursor: pointer;" v-if="record.email">{{record.email}}</span></div>
			</template>

			<template slot="inviteUserEmail" slot-scope="text, record">
				<div @click="toInviteEmail(record.inviteUserEmail)">
					<span style="cursor: pointer;" v-if="record.inviteUserEmail">{{record.inviteUserEmail}}</span></div>
			</template>

			<template slot="createTime" slot-scope="text, record">
				<div @click="toShowIp(record.operateIp)">
					<span style="cursor: pointer;" >{{record.createTime}}</span></div>
			</template>
			<template slot="whatsApp" slot-scope="text, record">
				<div @click="toWatsApp(record.whatsApp)">
					<span style="cursor: pointer;" v-if="record.whatsApp">{{record.whatsApp}}</span></div>
			</template>
			<template slot="orderStatus" slot-scope="text, record">
				<div>
					{{ $enums.orderStatusEnum.getLabelByValue(record.orderStatus) }}
				</div>
			</template>
			<template slot="complaintStatus" slot-scope="text, record">
				<div>
					{{ $enums.verifyStatusEnum.getLabelByValue(record.complaintStatus) }}
				</div>
			</template>


			<template slot="simulateStatus" slot-scope="text, record">
				<div>
					{{ $enums.simulateStatusEnum.getLabelByValue(record.simulateStatus) }}
				</div>
			</template>


			<template slot="vipAwardPrice" slot-scope="text, record">
				<div>
					{{ record.vipAwardPrice |formatAmount}}
				</div>
			</template>


			<template slot="unitPrice" slot-scope="text, record">
				<div>
					{{ record.unitPrice |formatAmount}}
				</div>
			</template>


			<template slot="orderPrice" slot-scope="text, record">
				<div>
					{{ record.orderPrice |formatAmount}}
				</div>
			</template>
			<template slot="totalPrice" slot-scope="text, record">
				<div>
					{{ record.totalPrice |formatAmount}}
				</div>
			</template>



			<template slot="commodityName" slot-scope="text, record">
				<div>
					{{ record.commodityName}}
				</div>
				<div v-if="record.commodityRemark">[{{record.commodityRemark}}]</div>
			</template>
			<template slot="orderImagesList" slot-scope="text, record">
				<viewer :images="record.orderImagesList" >
					<div class="er_content">
						<img class="er_content_img" :src="img" v-for="(img,index) in record.orderImagesList" :key="index" >
					</div>
				</viewer>
			</template>
			<!--     -->
			<template slot="action" slot-scope="text, record">
				<div class="flex_column">
					<a-button type="link" @click="toDetail(record)" class="mr12">查看详情</a-button>
					<!-- orderStatus VERIFY 审核中 才能审核 -->
					 <!--  -->
					<a-button  type="link"  v-if="hasPermission('PER_AUDIT')&&record.orderStatus === 'VERIFY'"
						@click="toVerify(record,'1')">审核</a-button>

					<!-- complaintStatus 为 VERIFT 可以申诉处理 -->
					  <!-- -->
					<a-button type="link"   v-if="hasPermission('PER_COMPLAINT')&&record.complaintStatus === 'VERIFT'"
						@click="toVerify(record,'2')">处理申诉订单</a-button>

				</div>
			</template>
		</a-table>
		<a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk" @cancel="cancelTips">
			<span>
				{{ tipsModel.content }}
			</span>
		</a-modal>


		<!-- <a-modal
      :title="deliveryModel.title"
      :visible="deliveryModel.flag"
      width="700px"
      @ok="sureDelivery"
      @cancel="deliveryModel.flag = false"
    >
      <a-form-model
        :model="deliveryModel"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="快递公司">
          <a-select v-model="deliveryModel.expressName" placeholder="快递公司">
            <a-select-option
              v-for="(item, index) of expressList"
              :key="index"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="发货单号">
          <a-input
            v-model="deliveryModel.tradeOrderNo"
            placeholder="发货单号"
          ></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal> -->
		<!-- 查看详情 -->
		<a-modal :title="detailModel.title" :visible="detailModel.flag" width="1200px" @ok="detailModel.flag = false"
			@cancel="detailModel.flag = false">
			<a-form-model :model="detailModel" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="ID">
							<span>
								{{ detailModel.orderId }}
							</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="时间">
							<span>
								{{ detailModel.createTime }}
							</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="订单编号">
							<span>{{ detailModel.orderNo?detailModel.orderNo:'' }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="订单状态">
							<span>{{
                $enums.orderStatusEnum.getLabelByValue(
                  detailModel.orderStatus
                )
              }}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="申诉状态">
							<span>{{
                $enums.verifyStatusEnum.getLabelByValue(
                  detailModel.complaintStatus
                )
              }}</span>
						</a-form-model-item>
					</a-col>

					<a-col :span="12">
						<a-form-model-item label="卡片分类[备注]">
							<span>{{detailModel.commodityName}}</span>
							<span>[{{detailModel.commodityRemark}}]</span>
						</a-form-model-item>
					</a-col>

				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="卡片名称">
							<span>
								{{ detailModel.giftCardName }}
							</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="国家">
							<span>{{ detailModel.countryName?detailModel.countryName:'' }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="金额">
							<div>{{ detailModel.orderPrice|formatAmount }}</div>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="汇率">
							<div>
								{{ detailModel.unitPrice|formatAmount }}
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="图片">
							<viewer :images="detailModel.orderImagesList" >
								<div class="er_content flex flex_wrap" >
									<img class="er_content_img" style="object-fit: contain;" :src="img" v-for="(img,index) in detailModel.orderImagesList" :key="index" >
								</div>
							</viewer>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="交易总价">
							<span>{{ detailModel.totalPrice|formatAmount }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="会员昵称 ">
							<span style="padding-right: 5px;" v-if="detailModel.nickname">{{detailModel.nickname}}</span>
					<span style="padding:2px 5px;background-color: rgb(235,96,97);color: #fff;border-radius: 3px;user-select: none;" v-if="detailModel.vipName">{{detailModel.vipName}}</span>
							<!-- <span> {{ detailModel.nickname }} {{ detailModel.vipName }}</span> -->
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="email">
							<span @click="toEmail(detailModel.email)"  style="cursor: pointer;" v-if="detailModel.email">{{ detailModel.email }}
							</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>

					<a-col :span="12">
						<a-form-model-item label="WhatsApp">
							<span @click="toWatsApp(detailModel.whatsApp)"  style="cursor: pointer;" v-if="detailModel.whatsApp">
								{{ detailModel.whatsApp }}
							</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="操作人">
							<span>
								{{ detailModel.managerName }}
							</span>
						</a-form-model-item>
					</a-col>
				</a-row>

				<a-row>
					<a-col :span="12">
						<a-form-model-item label="模拟用户">
							<span>
								{{ $enums.simulateStatusEnum.getLabelByValue(detailModel.simulateStatus) }}
							</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="推荐人">
							<span @click="toInviteEmail(detailModel.inviteUserEmail)" style="cursor: pointer;" v-if="detailModel.inviteUserEmail">
								{{ detailModel.inviteUserEmail }}
							</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="反馈文字">
							<span>
								{{ detailModel.feedbackRemark }}
							</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="反馈图">
							<!-- <div class="flex flex_wrap"
								v-if="detailModel.feedbackImage!=null&&detailModel.feedbackImageList.length>0">
								<div style="width: 100px;height: 100px;"
									v-for="(item, index) of detailModel.feedbackImageList" :key="index">
									<img :src="item" alt="" style="width: 100%;height: 100%;object-fit: contain;" />
								</div>
							</div> -->

							<viewer :images="detailModel.feedbackImageList" >
								<div class="er_content flex flex_wrap" >
									<img class="er_content_img" style="object-fit: contain;" :src="img" v-for="(img,index) in detailModel.feedbackImageList" :key="index" >
								</div>
							</viewer>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="用户申诉描述">
							<span>
								{{ detailModel.complaintUserRemark }}
							</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="用户申诉图">
							<viewer :images="detailModel.complaintUserImagesList" >
								<div class="er_content flex flex_wrap" >
									<img class="er_content_img" style="object-fit: contain;" :src="img" v-for="(img,index) in detailModel.complaintUserImagesList" :key="index" >
								</div>
							</viewer>

						</a-form-model-item>
					</a-col>


					<a-col :span="12">
						<a-form-model-item label="后台申诉反馈描述">
							<span>
								{{ detailModel.complaintManagerRemark }}
							</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="后台申诉反馈图片">
							<viewer :images="detailModel.complaintManagerImagesList" >
								<div class="er_content flex flex_wrap" >
									<img class="er_content_img" style="object-fit: contain;" :src="img" v-for="(img,index) in detailModel.complaintManagerImagesList" :key="index" >
								</div>
							</viewer>
						</a-form-model-item>
					</a-col>

				</a-row>
			</a-form-model>
		</a-modal>
		<!--  -->
		<a-modal :title="verifyModel.title" :visible="verifyModel.flag" width="700px" @ok="sureVerify"
			@cancel="verifyModel.flag = false">
			<a-form-model :model="verifyModel" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row>
					<a-col :span="20">
						<a-form-model-item label="头像">
							<div v-if="verifyModel.avatar !== null">
					<viewer :images="[verifyModel.avatar]" >
									<div class="er_content">
										<img class="er_content_img" :src="img" v-for="(img,index) in [verifyModel.avatar]" :key="index" >
									</div>
								</viewer>
					<!-- <img :src="record.avatar" alt="" style="width: 100px;height: 100px" @click="toSeeImg(record)" /> -->
				</div>
				<div v-else>-</div>


						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="20">

						<a-form-model-item label="昵称">
							<div>
							<span style="padding-right: 5px;cursor: pointer;" v-if="verifyModel.nickname">{{verifyModel.nickname}}</span>
					<span style="padding:1px 5px;background-color: rgb(235,96,97);color: #fff;border-radius: 3px;user-select: none;" v-if="verifyModel.vipName">{{verifyModel.vipName}}</span>
				</div>

						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="20">
						<a-form-model-item label="邮箱">
							<div @click="toEmail(verifyModel.email)">
					<span style="cursor: pointer;" v-if="verifyModel.email">{{verifyModel.email}}</span></div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="20">
						<a-form-model-item label="whatsApp">
							<div @click="toWatsApp(verifyModel.whatsApp)">
					<span style="cursor: pointer;" v-if="verifyModel.whatsApp">{{verifyModel.whatsApp}}</span></div>

						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="20">
						<a-form-model-item label="上级推荐人">
							<div @click="toUserEmail(verifyModel.inviteUserEmail)">
					<span style="cursor: pointer;" v-if="verifyModel.inviteUserEmail">{{verifyModel.inviteUserEmail}}</span></div>
						</a-form-model-item>
					</a-col>
				</a-row>


				<a-row v-if="verifyModel.isValue=='1'">
					<a-col :span="20">
						<a-form-model-item label="审核状态">
							<a-select v-model="verifyModel.orderStatus" placeholder="审核状态"   show-search option-filter-prop="label" :filter-option="filterOption">
								<a-select-option v-for="(item, index) of exStatus1" :key="index" :value="item.value">
									{{ item.label }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row v-if="verifyModel.isValue=='2'">
					<a-col :span="20">
						<a-form-model-item label="申诉状态">
							<a-select v-model="verifyModel.complaintStatus" placeholder="申诉状态"   show-search option-filter-prop="label" :filter-option="filterOption">
								<a-select-option v-for="(item, index) of exStatus2" :key="index" :value="item.value">
									{{ item.label }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row v-if="verifyModel.isValue=='1'">
					<a-col :span="20">
						<a-form-model-item label="反馈图">
							<viewer :images="verifyModel.feedbackImageList" >
								<div class="er_content flex flex_wrap" style="display: flex;flex-direction: row;flex-wrap: wrap;">
									<div style="position: relative;width: 100px;height: 100px;margin: 0 5px;display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;" class=" "  v-for="(img,index) in verifyModel.feedbackImageList" :key="index">
										<img class="er_content_img" :src="img" >
										<div class="er_del" @click="del(index,'1')">
											<span class="text">x</span>
										</div>
									</div>

								</div>
							</viewer>
							<div class="again_upload_box ml12">
								<input type="file" multiple accept="image/" @change="handleUpdataFile" />
								<i class="el-icon-box again_upload_icon"></i>
								<div class="bold" style="width: 100px">上传文件</div>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row  v-if="verifyModel.isValue=='2'">
					<a-col :span="20">
						<a-form-model-item label="后台申诉反馈图">
							<!-- files -->
							 <viewer :images="verifyModel.complaintManagerImagesList" >

									<div class="er_content flex flex_wrap" style="display: flex;flex-direction: row;flex-wrap: wrap;">
									<div style="position: relative;width: 100px;height: 100px;margin: 0 5px;display: flex
;
    flex-direction: row;
    align-items: center;
    justify-content: center;" class=" "  v-for="(img,index) in verifyModel.complaintManagerImagesList" :key="index">
										<img class="er_content_img" :src="img" >
										<div class="er_del" @click="del(index,'2')">
											<span class="text">x</span>
										</div>
									</div>

								</div>
								</viewer>

							<!-- <viewer :images="verifyModel.complaintManagerImages" >
								<div class="er_content flex flex_wrap" >
									<img class="er_content_img" style="object-fit: contain;" :src="verifyModel.feedbackImage" >
								</div>
							</viewer> -->
							<div class="again_upload_box ml12">
								<input type="file" multiple accept="image/" @change="handleUpdataFile" />
								<i class="el-icon-box again_upload_icon"></i>
								<div class="bold" style="width: 100px">上传文件</div>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row v-if="verifyModel.isValue=='1'">
					<a-col :span="20">
						<a-form-model-item label="反馈文字">
							<a-input v-model="verifyModel.feedbackRemark" placeholder="反馈文字"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row v-if="verifyModel.isValue=='2'">
					<a-col :span="20">
						<a-form-model-item label="后台申诉反馈描述">
							<a-input v-model="verifyModel.complaintManagerRemark"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="20">
						<a-form-model-item label="卡片分类">
							<a-select v-model="verifyModel.giftCardId" placeholder="卡类型" @change="handleCardChange"   show-search option-filter-prop="name" :filter-option="filterOption">
								<a-select-option v-for="(item, index) of tableCardData" :key="index"
									:value="item.giftCardId">
									{{ item.name }}
								</a-select-option>
							</a-select>
							<a-select v-model="verifyModel.countryId" placeholder="国家" @change="handleCountryChange"   show-search option-filter-prop="name" :filter-option="filterOption">
								<a-select-option v-for="(item, index) of tableCountryData" :key="index"
									:value="item.countryId">
									{{ item.name }}
								</a-select-option>
							</a-select>
							<a-select v-model="verifyModel.commodityId" placeholder="分类价格"
								@change="handleCommodityChange"   show-search option-filter-prop="commodityName" :filter-option="filterOption">
								<a-select-option v-for="(item, index) of tableCommodityData" :key="index"
									:value="item.commodityId">
									{{ item.commodityName }}{{verifyModel.commodityRemark}}
									<!-- <text>[]</text> -->
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="20">
						<a-form-model-item label="金额">
							<a-input v-model="verifyModel.orderPrice" placeholder="金额"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>

				<a-row>
					<a-col :span="20">
						<a-form-model-item label="图片">
							 <viewer :images="verifyModel.orderImagesList" >

									<div class="er_content flex flex_wrap" style="display: flex;flex-direction: row;flex-wrap: wrap;">
									<div style="position: relative;width: 100px;height: 100px;margin: 0 5px;display: flex
;
    flex-direction: row;
    align-items: center;
    justify-content: center;" class=" "  v-for="(img,index) in verifyModel.orderImagesList" :key="index">
										<img class="er_content_img" :src="img" >
										<!-- @click="del(index,'3')" -->
										<!-- <div class="er_del" >
											<span class="text">x</span>
										</div> -->
									</div>

								</div>
								</viewer>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row v-if="verifyModel.isValue=='2'">
					<a-col :span="20">
						<a-form-model-item label="用户申诉描述">
							<div>{{verifyModel.complaintUserRemark}}</div>
							<!-- <a-input v-model="" placeholder="用户申诉描述"></a-input> -->
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row v-if="verifyModel.isValue=='2'">
					<a-col :span="20">
						<a-form-model-item label="用户申诉图">
							 <viewer :images="verifyModel.complaintUserImagesList" >

									<div class="er_content flex flex_wrap" style="display: flex;flex-direction: row;flex-wrap: wrap;">
									<div style="position: relative;width: 100px;height: 100px;margin: 0 5px;display: flex
;
    flex-direction: row;
    align-items: center;
    justify-content: center;" class=" "  v-for="(img,index) in verifyModel.complaintUserImagesList" :key="index">
										<img class="er_content_img" :src="img" >
										<!-- @click="del(index,'3')" -->
										<!-- <div class="er_del" >
											<span class="text">x</span>
										</div> -->
									</div>

								</div>
								</viewer>
						</a-form-model-item>
					</a-col>
				</a-row>

			</a-form-model>
		</a-modal>

		<a-modal :visible="imgModel.flag" width="880px" :closable="false" maskClosable :destroyOnClose="true">
			<template slot="footer">
				<a-button @click="imgModel.flag = false">关闭</a-button>
			</template>
			<span>
				<img :src="imgModel.url" alt="" style="width: 800px;height: 296px" />
			</span>
		</a-modal>

	</div>
</template>

<script>
	import {
		// orderListApi,
		// orderDetailApi,
		// orderverifyApi,
		// orderComplaintApi,
		// orderListImportApi,
		// cardListCardsApi,
		// cardListCountryApi,
		// cardListCommodityApi,
		getCountryApi,
		getOssAuth
	} from "../../api/index";
	import {getFormatAmount} from "../../utils/util"
	export default {
		name: "ORDERLIST",
		data() {
			return {
				disable:false,
				uploadingLoading:false,
				filterData: {
					timeDate: [],
					orderNo: "",
					orderStatus: undefined,
					email: "",
					whatsApp: "",
					inviteUserEmail: "",
					complaintStatus: undefined,
					simulateStatus: undefined,
					managerName: "",
					orderByTitle: "",
					orderBy: "",
					giftCardId: undefined,
					countryId: undefined,
					commodityName: "",
					nickname: "",
				},
				columns: [{
						title: "创建时间",
						key: "createTime",
						sorter: true,
					scopedSlots: {
						customRender: "createTime"
					},
						// sorter: (a, b) => {
						// 	const time1 = new Date(a.createTime).getTime();
						// 	const time2 = new Date(b.createTime).getTime();
						// 	return time1 - time2;
						// },
					},
					{
						title: "订单编号",
						dataIndex: "orderNo",
						key: "orderNo",
						// width: 150,
					},
					{
						title: "订单状态",
						key: "orderStatus",
						scopedSlots: {
							customRender: "orderStatus"
						},
						// width: 150,
					},
					{
						title: "卡片名称",
						dataIndex: "giftCardName",
						key: "giftCardName",
						// width: 150,
					},
					{
						title: "国家",
						dataIndex: "countryName",
						key: "countryName",
						// width: 150,
					},
					{
						title: "卡片分类[备注]",
						key: "commodityName",
						scopedSlots: {
							customRender: "commodityName"
						},
						width: 300,
					},
					{
						title: "金额",
						dataIndex: "orderPrice",
						key: "orderPrice",
						scopedSlots: {
							customRender: "orderPrice"
						},
						sorter: true,
					},
					{
						title: "汇率",
						dataIndex: "unitPrice",
						key: "unitPrice",
						scopedSlots: {
							customRender: "unitPrice"
						},
						// width: 150,
					},
					{
						title: "图片",
						dataIndex: "orderImagesList",
						key: "orderImagesList",
						scopedSlots: {
							customRender: "orderImagesList"
						},
					},
					{
						title: "交易总价",
						dataIndex: "totalPrice",
						key: "totalPrice",
						scopedSlots: {
							customRender: "totalPrice"
						},
						// width: 150,
					},
					{
						title: "vip等级奖励",
						dataIndex: "vipAwardPrice",
						key: "vipAwardPrice",
						scopedSlots: {
							customRender: "vipAwardPrice"
						},
						// width: 150,
					},
					{
						title: "会员昵称",
						key: "nickname",
						scopedSlots: {
							customRender: "nickname"
						},
					},
					// {
					// 	title: "等级名称",
					// 	dataIndex: "vipName",
					// 	key: "vipName",
					// 	width: 150,
					// },
					{
						title: "邮箱",
						dataIndex: "email",
						key: "email",
						// width: 150,
						scopedSlots: {
							customRender: "email"
						},
					},
					{
						title: "whatsApp",
						dataIndex: "whatsApp",
						key: "whatsApp",
						scopedSlots: {
							customRender: "whatsApp"
						},
						// width: 150,
					},
					{

						title: "模拟用户",
						key: "simulateStatus",
						scopedSlots: {
							customRender: "simulateStatus"
						},
						// width: 150,
					},
					{
						title: "申诉状态",
						key: "complaintStatus",
						scopedSlots: {
							customRender: "complaintStatus"
						},
						// width: 150,
					},
					{
						title: "上级推荐人",
						dataIndex: "inviteUserEmail",
						key: "inviteUserEmail",
						// width: 150,
						scopedSlots: {
							customRender: "inviteUserEmail"
						},
					},
					{
						title: "操作人",
						dataIndex: "managerName",
						key: "managerName",
						// width: 150,
					},
					{
						title: "操作时间",
						dataIndex: "managerTime",
						key: "managerTime",
						// width: 150,
						sorter: true,
						// sorter: (a, b) => {
							// 将日期字符串转换为时间戳进行比较 :cite[5]:cite[7]:cite[10]
							// const time1 = new Date(a.managerTime).getTime();
							// const time2 = new Date(b.managerTime).getTime();
							// return time1 - time2; // 升序排列
						// },
					},
					{
						title: "操作",
						key: "action",
						align: "center",
						// width: 100,
						fixed: 'right',
						scopedSlots: {
							customRender: "action"
						},
					},

				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				options: [{
						label: "审核中",
						value: "VERIFY",
					},
					{
						label: "成功",
						value: "SUCCESS",
					},
					{
						label: "失败",
						value: "FAIL",
					},
				],
				exStatus2: [{
						label: "成功",
						value: "SUCCESS",
					},
					{
						label: "失败",
						value: "FAIL",
					},
					// {
					// 	label: "未申诉",
					// 	value: "UN_COMPLAINT",
					// },
					// {
					// 	label: "申诉审核中",
					// 	value: "VERIFT",
					// },
				],
				exStatus1: [{
						label: "成功",
						value: "SUCCESS",
					},
					{
						label: "失败",
						value: "FAIL",
					},
					// {
					// 	label: "审核中",
					// 	value: "VERIFY",
					// },
				],
				tipsModel: {
					flag: false,
					title: "",
					content: "",
					orderId: "",
					orderStatus: "",
					onOk: () => {},
				},
				verifyModel: {
					flag: false,
					isValue:"",
					title: "",
					giftCardId: "",
					giftCardName: "",
					countryId: "",
					countryName: "",
					commodityId: "",
					commodityName: "",
					orderStatus: undefined,
					feedbackImage: "",
					feedbackRemark: "",
					complaintStatus:undefined,
					complaintManagerImages: "",
					complaintManagerRemark: "",
					feedbackImageList:[],
					complaintManagerImagesList:[],
					orderImagesList:[],
					orderPrice: "",
					orderId: "",
					avatar:"",
					nickname:"",
					vipName:"",
					email:"",
					whatsApp:"",
					inviteUserEmail:"",
					commodityRemark:"",
				},
				labelCol: {
					span: 6
				},
				wrapperCol: {
					span: 18
				},
				deliveryModel: {
					flag: false,
					title: "",
					orderId: 1,
					expressName: "",
					tradeOrderNo: "",
				},
				detailModel: {},
				specialProcess: [],
				expressList: [],
				tableCardData: [],
				tableCountryData: [],
				tableCommodityData: [],
				countryData:[],
				giftCardId: "",
				countryId: "",
				orderStatusList: [], //订单状态
				complaintStatusList: [], //申诉状态
				simulateStatusList: [], //模拟用户
				// ASC 递增 DESC 递减
				// orderByTitleList: [{
				// 		label: "递增",
				// 		value: "ASC",
				// 	},
				// 	{
				// 		label: "递减",
				// 		value: "DESC",
				// 	},
				// ], //排序使用
				// 判断是审核订单还是申诉订单
				isReviewOrAppeal: "",
				imgModel: {
					flag: false,
					url: "",
				},
				files1: [],
				files2: [],
				orderStaticsVO:{

				}

			};
		},

		 watch: {
			// '$store.state.isLoggedIn': {

			// handler(newVal, oldVal) {
			// 	console.log('isLoggedIn')
			// 	const storedQuery = localStorage.getItem('order_searchQuery');
			// 	if(storedQuery){
			// 		 console.log('这里触发了吗1111')
			// 		this.filterData = JSON.parse(storedQuery);
			// 	}
			// 	if(newVal==true){
			// 		 console.log('这里触发了吗2222')
			// 		this.filterData.orderStatus = "VERIFY"
			// 	} else {
			// 		 console.log('这里触发了吗3333')
			// 		this.filterData.orderStatus = undefined
			// 	}
			// 	this.getData(1);
			// },
			// immediate: true // 可选：立即执行一次
			// },
			'$route': {
			handler(newVal, oldVal) {
				if(newVal.query.clear==true){
					this.filterData = {
						timeDate: [],
						orderNo: "",
						orderStatus: undefined,
						email: "",
						whatsApp: "",
						inviteUserEmail: "",
						complaintStatus: undefined,
						simulateStatus: undefined,
						managerName: "",
						giftCardId: undefined,
						countryId: undefined,
						orderBy:"",
						orderByTitle:"",
						commodityName: "",
						nickname: "",
					}

					this.filterData.orderStatus = newVal.query.orderStatus
					this.filterData.deleteStatus = newVal.query.deleteStatus
					if(newVal.query.isDate==true){
						// this.filterData.timeDate = [this.$moment(),this.$moment()]
						this.filterData.timeDate = [ localStorage.getItem('endDate'), localStorage.getItem('endDate')]
					}

					// this.filterData.orderStatus = "SUCCESS"
				} else {
					const value = newVal.query.key
					const storedQuery = localStorage.getItem('order_searchQuery')
					if(storedQuery){
						this.filterData = JSON.parse(storedQuery)
					}
					if(value=="1"){
						this.filterData.orderStatus = "VERIFY"
						this.filterData.complaintStatus = undefined
					} else if(value=="2"){
						this.filterData.orderStatus = undefined
						this.filterData.complaintStatus = "VERIFT"
					} else {
					}
					this.getData(1)
				}
			},
			immediate: true // 可选：立即执行一次
			}
		},
		mounted() {
			this.getCountrySetData()
			this.getCardData(1)
			if(this.$route.query.clear==true){
				this.filterData = {
					timeDate: [],
					orderNo: "",
					orderStatus: undefined,
					email: "",
					whatsApp: "",
					inviteUserEmail: "",
					complaintStatus: undefined,
					simulateStatus: undefined,
					managerName: "",
					giftCardId: undefined,
					countryId: undefined,
					orderBy:"",
					orderByTitle:"",
					commodityName: "",
					nickname: "",
				}
				this.filterData.orderStatus = this.$route.query.orderStatus
				this.filterData.deleteStatus = this.$route.query.deleteStatus
				if(this.$route.query.isDate==true){
					// this.filterData.timeDate = [this.$moment(),this.$moment()]
					this.filterData.timeDate = [ localStorage.getItem('endDate'), localStorage.getItem('endDate')]
				}
				this.getData(1);
			} else {
				const storedQuery = localStorage.getItem('order_searchQuery');
				if(storedQuery){
					this.filterData = JSON.parse(storedQuery);
					this.getCountryData(2,this.filterData.giftCardId)

					if(this.$route.query.status=="VERIFY"&&this.$route.query.key=="1"){
						this.filterData.orderStatus = "VERIFY"
						this.filterData.complaintStatus = undefined
					} else if(this.$route.query.status=="VERIFT"&&this.$route.query.key=="2"){
						this.filterData.orderStatus = undefined
						this.filterData.complaintStatus = "VERIFT"
					} else {
					}
					this.getData(1);
				} else {
					this.getData(1);
				}
			}
		},
		beforeRouteLeave(to, from, next) {
			console.log(this.filterData,'==')
			localStorage.setItem('order_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {
			 hasPermission(permission) {
				return this.$store.state.userInfo.resources.split(";").includes(permission)
			},
			toInviteEmail(email){
				this.$router.push({
					name: 'VIPLIST',
					query: {
						key:'1',
					email: email
					}
				});
			},
			toEmail(email){

				this.$router.push({
					name: 'VIPLIST',
					query: {
						key:'2',
					email: email
					}
				});
			},
			toWatsApp(whatsAppNumber){
				window.open(`https://wa.me/+234${whatsAppNumber}`, '_blank')
			},
			handleBlur() {
				console.log('blur');
			},
			handleFocus() {
				console.log('focus');
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			toSeeImg(data) {
				this.imgModel = {
					flag: true,
					url: data.iconUrl,
				};
			},
			changePage(page, filters, sorter) {
				this.pageInfo.current = page.current;
				// 处理排序信息

				// 排序使用 ASC 递增 DESC 递减
				 if (sorter && sorter.field) {
					this.filterData.orderByTitle = sorter.field; // 排序字段（如 "orderPrice"）
					if(sorter.order=="ascend"){
						this.filterData.orderBy="ASC"
					} else if(sorter.order=="descend"){
						this.filterData.orderBy="DESC"
					} else {

					}
				} else {
				// 若取消排序，清空参数
					this.filterData.orderBy = "";
					this.filterData.orderByTitle=""
				}

				this.getData(this.pageInfo.current);
			},
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					this.filterData = {
						timeDate: [],
						orderNo: "",
						orderStatus: undefined,
						email: "",
						whatsApp: "",
						inviteUserEmail: "",
						complaintStatus: undefined,
						simulateStatus: undefined,
						managerName: "",
						giftCardId: undefined,
						countryId: undefined,
						orderBy:"",
						orderByTitle:"",
						commodityName: "",
						nickname: "",
					};
					localStorage.setItem('order_searchQuery', JSON.stringify(this.filterData));

					this.getData(1);
				}
			},
			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				orderListApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						startDate: this.filterData.timeDate.length === 2 ?
							this.$moment(this.filterData.timeDate[0]).format(
								"YYYY-MM-DD"
							) : null,
						endDate: this.filterData.timeDate.length === 2 ?
							this.$moment(this.filterData.timeDate[1]).format(
								"YYYY-MM-DD"
							) : null,
						orderNo: this.filterData.orderNo,
						orderStatus: this.filterData.orderStatus,
						email: this.filterData.email,
						whatsApp: this.filterData.whatsApp,
						inviteUserEmail: this.filterData.inviteUserEmail,
						complaintStatus: this.filterData.complaintStatus,
						simulateStatus: this.filterData.simulateStatus,
						managerName: this.filterData.managerName,
						orderByTitle: this.filterData.orderByTitle,
						orderBy: this.filterData.orderBy,
						giftCardId: this.filterData.giftCardId,
						countryId: this.filterData.countryId,
						commodityName: this.filterData.commodityName,
						nickname: this.filterData.nickname
					})
					.then((res) => {
						console.log(res,'==========================-------===========')
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];this.tableData.forEach(item => {
								item.orderImagesList = item.orderImages.split(';').filter(url => url.trim() !==
									'');
							});
							this.pageInfo.total = res.resultData.totalNum || 0;
							this.orderStaticsVO = res.resultData.orderStaticsVO
						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},

			getCountData(e){
				console.log(e,'Hhh')
				this.filterData.countryId = ''
				this.tableCountryData=[]
				this.getCountryData(2,e)
				this.getData(1);
			},

			onChangeDate() {

				this.getData(1);
			},
			toExport() {
				// if (this.loading) {
				//   return;
				// }
				// this.loading = true;
				// orderListExportApi({
				//   pageNo: this.pageInfo.current,
				//   pageSize: this.pageInfo.pageSize,
				//   startDate:
				//     this.filterData.timeDate.length === 2
				//       ? this.$moment(this.filterData.timeDate[0]).format(
				//           "YYYY-MM-DD 00:00:00"
				//         )
				//       : null,
				//   endDate:
				//     this.filterData.timeDate.length === 2
				//       ? this.$moment(this.filterData.timeDate[1]).format(
				//           "YYYY-MM-DD 23:59:59"
				//         )
				//       : null,
				//   keywords: this.filterData.keywords,
				//   orderType: this.filterData.orderType,
				//   username: this.filterData.username,
				// })
				//   .then((res) => {
				//     this.$convertRes2Blob(res, "订单列表导出数据");
				//     this.$message.success("導出成功");
				//   })
				//   .catch((err) => {
				//     console.error(err);
				//   })
				//   .finally(() => {
				//     this.loading = false;
				//   });
			},
			toDetail(data) {
				orderDetailApi({
						orderId: data.orderId,
					})
					.then((res) => {
						if (res.resultStatus) {
							const result = res.resultData;
							this.detailModel = {
								flag: true,
								title: "查看详情：" + result.orderNo,
								...result
							};
							if (this.detailModel.orderImages != null&&this.detailModel.orderImages != "" && this.detailModel.orderImages.indexOf(";") !== -
								1) {
								this.detailModel.orderImagesList = this.detailModel.orderImages.split(';')
							} else if(this.detailModel.orderImages != null&&this.detailModel.orderImages != "" && this.detailModel.orderImages.indexOf(";") ==-1) {
								this.detailModel.orderImagesList = [this.detailModel.orderImages]
							} else {
								this.detailModel.orderImagesList = []
							}
							console.log(this.detailModel.orderImagesList, '3')

							if (this.detailModel.feedbackImage != null&&this.detailModel.feedbackImage != "" && this.detailModel.feedbackImage.indexOf(
									";") !== -1) {
								this.detailModel.feedbackImageList = this.detailModel.feedbackImage.split(';')
							} else if(this.detailModel.feedbackImage != null&&this.detailModel.feedbackImage != "" && this.detailModel.feedbackImage.indexOf(";") ==-1) {
								this.detailModel.feedbackImageList = [this.detailModel.feedbackImage]
							} else {
								this.detailModel.feedbackImageList = []
							}

							if (this.detailModel.complaintUserImages != null&&this.detailModel.complaintUserImages != "" && this.detailModel.complaintUserImages
								.indexOf(";") !== -1) {
								this.detailModel.complaintUserImagesList = this.detailModel.complaintUserImages.split(
									';')
							} else if(this.detailModel.complaintUserImages != null&&this.detailModel.complaintUserImages != "" && this.detailModel.complaintUserImages.indexOf(";") ==-1) {
								this.detailModel.complaintUserImagesList = [this.detailModel.complaintUserImages]
							} else {
								this.detailModel.complaintUserImagesList = []
							}

							if (this.detailModel.complaintManagerImages != null&&this.detailModel.complaintManagerImages != "" && this.detailModel
								.complaintManagerImages.indexOf(";") !== -1) {
								this.detailModel.complaintManagerImagesList = this.detailModel.complaintManagerImages
									.split(';')
							} else if(this.detailModel.complaintManagerImages != null&&this.detailModel.complaintManagerImages != "" && this.detailModel.complaintManagerImages.indexOf(";") ==-1) {
								this.detailModel.complaintManagerImagesList = [this.detailModel.complaintManagerImages]
							} else {
								this.detailModel.complaintManagerImagesList = []
							}

							console.log(this.detailModel.orderImagesList)
							console.log(this.detailModel.feedbackImageList)
							console.log(this.detailModel.complaintUserImagesList)
							console.log(this.detailModel.complaintManagerImagesList)


						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log("error", error);
					});
			},
			onChangeStatus(type, data) {
				if (type === "abnormalStatus") {
					this.tipsModel = {
						flag: true,
						title: "异常订单",
						content: data.abnormalStatus ?
							"确认要修改订单为异常订单吗？" : "确认要取消此订单为异常订单吗？",
						orderId: data.orderId,
						onOk: this.sureChangeAbnormal,
					};
				} else if (type === "stopSendingStatus") {
					this.tipsModel = {
						flag: true,
						title: "停发订单",
						content: data.stopSendingStatus ?
							"确认要修改订单为停发订单吗？" : "确认要取消此订单为停发订单吗？",
						orderId: data.orderId,
						onOk: this.sureChangeStopSending,
					};
				}
			},
			sureChangeAbnormal() {
				if (this.loading) {
					return;
				}
				this.loading = true;
				abnormalStatusApi({
						orderId: this.tipsModel.orderId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("修改订单状态成功");
							this.tipsModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData(1);
					});
			},
			sureChangeStopSending() {
				if (this.loading) {
					return;
				}
				this.loading = true;
				stopSendingStatusApi({
						orderId: this.tipsModel.orderId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("修改订单状态成功");
							this.tipsModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData(1);
					});
			},
			toVerify(data, isValue) {
				this.isReviewOrAppeal = ''
				if (isValue == '1') {
					this.isReviewOrAppeal = '1'
				} else if (isValue == '2') {
					this.isReviewOrAppeal = '2'
				} else {}
				this.verifyModel = {
					flag: true,
					isValue:isValue,
					title: isValue == '1' ? "订单审核" : "处理申诉订单",
					giftCardId: data.giftCardId,
					giftCardName: data.giftCardName,
					countryId: data.countryId,
					countryName: data.countryName,
					commodityId: data.commodityId,
					commodityName: data.commodityName,
					// orderStatus: data.orderStatus,
					// complaintStatus:data.complaintStatus,
					feedbackImage: data.feedbackImage,
					feedbackRemark: data.feedbackRemark,
					complaintManagerImages: data.complaintManagerImages,
					complaintManagerRemark:data.complaintManagerRemark,
					orderPrice: data.orderPrice,
					orderId: data.orderId,
					avatar:data.avatar,
					nickname:data.nickname,
					vipName:data.vipName,
					email:data.email,
					whatsApp:data.whatsApp,
					inviteUserEmail:data.inviteUserEmail,
					complaintUserRemark:data.complaintUserRemark,
					commodityRemark:data.commodityRemark?'['+data.commodityRemark+']':""
				};

				if (data.feedbackImage != null&&data.feedbackImage != '' && data.feedbackImage.indexOf(";") !== -
						1) {
						this.verifyModel.feedbackImageList = data.feedbackImage.split(';')
					} else if(data.feedbackImage != null&&data.feedbackImage != '' && data.feedbackImage.indexOf(";") == -
						1){
						this.verifyModel.feedbackImageList = [data.feedbackImage]
					} else {
						this.verifyModel.feedbackImageList = []
					}
				if (data.complaintManagerImages != null&&data.complaintManagerImages != '' && data.complaintManagerImages.indexOf(";") !== -
						1) {
						this.verifyModel.complaintManagerImagesList = data.complaintManagerImages.split(';')
					}else if (data.complaintManagerImages != null&&data.complaintManagerImages != '' && data.complaintManagerImages.indexOf(";") == -
						1) {
						this.verifyModel.complaintManagerImagesList = [data.complaintManagerImages]
					} else {
						this.verifyModel.complaintManagerImagesList = []
					}

					if (data.orderImages != null&&data.orderImages != '' && data.orderImages.indexOf(";") !== -
						1) {
						this.verifyModel.orderImagesList = data.orderImages.split(';')
					}else if (data.orderImages != null&&data.orderImages != '' && data.orderImages.indexOf(";") == -
						1) {
						this.verifyModel.orderImagesList = [data.orderImages]
					} else {
						this.verifyModel.orderImagesList = []
					}

				if (data.complaintUserImages != null&&data.complaintUserImages != "" &&data.complaintUserImages
								.indexOf(";") !== -1) {
								this.verifyModel.complaintUserImagesList = data.complaintUserImages.split(
									';')
							} else if(data.complaintUserImages != null&&data.complaintUserImages != "" && data.complaintUserImages.indexOf(";") ==-1) {
								this.verifyModel.complaintUserImagesList = [data.complaintUserImages]
							} else {
								this.verifyModel.complaintUserImagesList = []
							}


				if (data.giftCardId != '') {
					this.giftCardId = data.giftCardId
				}
				if (data.giftCardId != '' && data.countryId != '') {
					this.countryId = data.countryId
					this.getCountryData(1)
				}
				if (data.giftCardId != '' && data.countryId != '' && data.commodityId != '') {
					this.getCommodityData(1)
				}
			},
			sureVerify() {
				if (this.isReviewOrAppeal == '1') {
					if(!this.verifyModel.orderStatus){
						this.$message.warn('审核状态不能为空');
						return
					}
					console.log('审核订单')
					if (this.loading) {
						return;
					}

					this.loading = true;
					orderverifyApi({
							orderId: this.verifyModel.orderId, //ID
							orderStatus: this.verifyModel.orderStatus, //审核状态  SUCCESS 成功、FAIL 失败
							feedbackImage: this.verifyModel.feedbackImageList.length>0?this.verifyModel.feedbackImageList.join(";"):'', //反馈图 多个;隔开
							feedbackRemark: this.verifyModel.feedbackRemark, //反馈文字
							commodityId: this.verifyModel.commodityId, //卡片分类Id  选择这个是时候，要三级联动
							orderPrice: this.verifyModel.orderPrice //金额
						})
						.then((res) => {
							if (res.resultStatus) {
								this.$message.success("操作成功");
								this.verifyModel.flag = false;
							} else {
								this.$message.warn(res.errorMessage);
								console.log("res", res);
							}
						})
						.catch((error) => {
							console.log(error);
						})
						.finally(() => {
							this.loading = false;
							this.getData(this.pageInfo.current);
						});

				} else if (this.isReviewOrAppeal == '2') {
					if(!this.verifyModel.complaintStatus){
						this.$message.warn('申诉状态不能为空');
						return
					}
					console.log('申诉订单')
					if (this.loading) {
						return;
					}
					this.loading = true;
					orderComplaintApi({
							orderId: this.verifyModel.orderId, //ID
							complaintStatus: this.verifyModel.complaintStatus, //
							complaintManagerImages: this.verifyModel.complaintManagerImagesList.length>0?this.verifyModel.complaintManagerImagesList.join(";"):"", //反馈图 多个;隔开
							complaintManagerRemark: this.verifyModel.complaintManagerRemark, //反馈文字
							commodityId: this.verifyModel.commodityId, //卡片分类Id  选择这个是时候，要三级联动
							orderPrice: this.verifyModel.orderPrice //金额
						})
						.then((res) => {
							if (res.resultStatus) {
								this.$message.success("操作成功");
								this.verifyModel.flag = false;
							} else {
								this.$message.warn(res.errorMessage);
								console.log("res", res);
							}
						})
						.catch((error) => {
							console.log(error);
						})
						.finally(() => {
							this.loading = false;
							this.getData(this.pageInfo.current);
						});
				} else {
				}

			},
			changeOrderStatus(data) {
				if (data.orderStatus === "VERIFYED") {
					this.tipsModel = {
						flag: true,
						title: "修改订单状态",
						content: "确认将订单状态修改为生产中？",
						orderId: data.orderId,
						orderStatus: "PRODUCTION",
						onOk: this.sureChangeStatus,
					};
				} else if (data.orderStatus === "PRODUCTION") {
					this.tipsModel = {
						flag: true,
						title: "修改订单状态",
						content: "确认将订单状态修改为包装中？",
						orderId: data.orderId,
						orderStatus: "PACKAGE",
						onOk: this.sureChangeStatus,
					};
				}
			},
			sureChangeStatus() {
				if (this.loading) {
					return;
				}
				this.loading = true;
				orderStatusApi({
						orderId: this.tipsModel.orderId,
						orderStatus: this.tipsModel.orderStatus,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("操作成功");
							this.tipsModel.flag = false;
						} else {
							// this.$message.warn(res.errorMessage);
							this.tipsModel.flag = false;
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData(this.pageInfo.current);
					});
			},
			sureDelivery() {
				if (!this.deliveryModel.expressName) {
					this.$message.warn("请输入快递公司");
					return;
				}
				if (!this.deliveryModel.tradeOrderNo) {
					this.$message.warn("请输入发货单号");
					return;
				}
				if (this.loading) {
					return;
				}
				this.loading = true;
				orderDeliveryApi({
						orderId: this.deliveryModel.orderId,
						expressName: this.deliveryModel.expressName,
						tradeOrderNo: this.deliveryModel.tradeOrderNo,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("操作成功");
							this.deliveryModel.flag = false;
						} else {
							// this.$message.warn(res.errorMessage);
							this.deliveryModel.flag = false;
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData(1);
					});
			},
			downloadPdf(url, currentName) {
				this.$downLoadPDF(url, currentName, "pdf");
			},
			cancelTips() {
				this.tipsModel.flag = false;
				this.getData(this.pageInfo.pageNo);
			},
			getCardData(page = 1) {
				// this.pageInfo.current = page;
				// if (this.loading) {
				//   return;
				// }
				// this.loading = true;
				cardListCardsApi(
					{
						pageNo:1,
						pageSize:9999
					}
				)
					.then((res) => {
						if (res.resultStatus) {
							this.tableCardData = res.resultData.dataList || [];
							console.log(this.tableCardData)
							// this.pageInfo.total = res.resultData.totalNum || 0;

						} else {
							this.tableCardData = [];
							// this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						// this.loading = false;
					});
			},
			// 系统设置里面的国家
			getCountrySetData(page = 1) {
				// this.pageInfoCountryData.current = page;
				// if (this.loading) {
				//   return;
				// }
				// this.loading = true;
				getCountryApi({
						pageNo:1,
						pageSize:9999
					})
					.then((res) => {
						if (res.resultStatus) {
							this.countryData = res.resultData.dataList || [];
							// this.pageInfoCountryData.total = res.resultData.totalNum || 0;
						} else {
							this.countryData = [];
							// this.pageInfoCountryData.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						// this.loading = false;
					});
			},
			// here
			getCountryData(e,value) {
				// this.pageInfo.current = page;
				// if (this.loading) {
				//   return;
				// }
				// this.loading = true;
				cardListCountryApi({
						pageNo:1,
						pageSize:9999,
						giftCardId: e==2?value:this.giftCardId
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableCountryData = res.resultData.records || [];
							console.log(this.tableCountryData)
							// this.pageInfo.total = res.resultData.totalNum || 0;
						} else {
							this.tableCountryData = [];
							// this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						// this.loading = false;
					});
			},
			getCommodityData(page = 1) {
				// this.pageInfo.current = page;
				// if (this.loading) {
				//   return;
				// }
				// this.loading = true;
				cardListCommodityApi({
					pageNo:1,
						pageSize:9999,
						giftCardId: this.giftCardId,
						countryId: this.countryId
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableCommodityData = res.resultData.dataList || [];
							console.log(this.tableCommodityData)
							// this.pageInfo.total = res.resultData.totalNum || 0;
						} else {
							this.tableCommodityData = [];
							// this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						// this.loading = false;
					});
			},


			handleCardChange(e) {
				this.giftCardId = ''
				this.countryId = ''
				this.giftCardId = e
				this.verifyModel.countryId = ''
				this.verifyModel.commodityId = ''
				this.getCountryData(1)
			},
			handleCountryChange(e) {
				this.verifyModel.commodityId = ''
				this.countryId = ''
				this.countryId = e
				this.getCommodityData(1)
			},
			handleCommodityChange(e) {},
			del(index,flag){
				if(flag=='1'){
					 this.verifyModel.feedbackImageList.splice(index, 1)
					 this.$forceUpdate()
				} else if(flag=='2'){
					this.verifyModel.complaintManagerImagesList.splice(index, 1)
					this.$forceUpdate()
				} else if(flag=='3'){
					// this.verifyModel.orderImagesList.splice(index, 1)
					// this.$forceUpdate()
				} else {

				}
				console.log(index,flag,'==============')
			},

			// 上传文件
			handleUpdataFile(e) {
				this.verifyModel.feedbackImageList=this.verifyModel.feedbackImageList.filter(v=>v!=null)
				if (e.target.files.length) {
					const selectedFiles = Array.from(e.target.files)
					if (selectedFiles) {
						selectedFiles.forEach(file => {
							const formData = new FormData();
							formData.append('file', file);
							getOssAuth(formData).then((res) => {
							if (res.resultStatus) {
								if(this.verifyModel.isValue=='1'){
									if(res.resultData.fileLink!=null){
										this.verifyModel.feedbackImageList.push(res.resultData.fileLink);
										this.$forceUpdate()
									}
																	}
								if(this.verifyModel.isValue=='2'){
									if(res.resultData.fileLink!=null){
										this.verifyModel.complaintManagerImagesList.push(res.resultData.fileLink);
										this.$forceUpdate()
									}
								}
							}
						});
						});
					}
				}
			},
			beforeUpload(file) {
				const isValidType = /\.(xlsx|xls|csv)$/i.test(file.name);
				const isSizeValid = file.size / 1024 / 1024 < 10;

				if (!isValidType) {
					this.$message.error('只能上传 Excel文件!');
					return false;
				}

				// if (!isSizeValid) {
				//   this.$message.error('文件大小不能超过 10MB!');
				//   return false;
				// }

				return true;
			},
			customRequest(options) {
				const {
					file,
					onSuccess,
					onError
				} = options;
				this.processFile(file)
			},
			// 订单导入
			processFile(file) {
				this.uploadingLoading = true
				if (file) {
					const formData = new FormData();
					formData.append("file", file);
					orderListImportApi(formData).then((res) => {
						if (res.resultData.fileUrl == null) {
							this.$message.success("导入成功");
							this.getData(1);
						} else {
							let fileUrl = res.resultData.fileUrl
							const encodedUrl = encodeURI(fileUrl);
							const link = document.createElement('a');
							link.href = encodedUrl;
							link.download = '未成功导入的订单.xlsx'; // 设置下载的文件名
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
						}
					}).catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.uploadingLoading = false;
					});
				}
			},
			toShowIp(ip){
				if(ip){
					window.open(`https://www.ip138.com/iplookup.php?ip=${ip}&action=2`, '_blank')
				}

			},

		},
	};
</script>

<style lang="less">
.flex{
	display: flex;
	flex-wrap: wrap;
}
	.order_list_page {
		width: 100%;
		height: 100%;
		padding: 10px;
		background: #ffffff;

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}

		.mb10 {
			margin-bottom: 10px;
		}
	}

	.clickPdf {
		text-decoration: underline;
		cursor: pointer;
		color: #1672fc;
	}
</style>
